import { styled } from '@mui/material';

const Logo = styled('span')({
    color: '#01a998',
    fontWeight: 800,
    fontSize: '25px',
});

const WebisteLogo = () => {
    return <Logo>Codewora</Logo>
}

export default WebisteLogo